import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Colli, ColliListResponse, ColliQueryParams, CreateColli, UpdateColli } from '@frontend/colli/types';

export class ColliClient extends APIClient {
    public static readonly endpoint = '/colli-api/v1';

    public static async fetchCollis(queryParams?: ApiQueryParams<ColliQueryParams>): Promise<ColliListResponse> {
        return await this.apiPaginated<ColliListResponse, ColliQueryParams>(`${this.endpoint}/collis`, queryParams);
    }

    public static async resolveCollis(ids: string[], field: string = 'id'): Promise<ColliListResponse> {
        return this.resolve<ColliListResponse>(`${this.endpoint}/collis`, ids, field);
    }

    public static async deleteCollis(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/collis-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postColli(accountId: string, transactionId: string, body: CreateColli): Promise<Colli> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis`, body);
        return await this.handleResponse<Colli>(response);
    }

    public static async fetchAccountTransactionColli(accountId: string, transactionId: string, colliId: string): Promise<Colli> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}`);
        return await this.handleResponse<Colli>(response);
    }

    public static async patchColli(accountId: string, transactionId: string, colliId: string, body: UpdateColli): Promise<Colli> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}`, body);
        return await this.handleResponse<Colli>(response);
    }

    public static async deleteColli(accountId: string, transactionId: string, colliId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}`);
        return await this.handleVoidResponse(response);
    }
}
